import { FaBolt, FaBook, FaBrain, FaChartLine } from "react-icons/fa6";
import { FaVoteYea } from "react-icons/fa";

import { Button } from "@heroui/button";
import { Link } from "@heroui/link";
import {
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@heroui/modal";
import { cn } from "@heroui/theme";

export const SignInToLikeResponseModalContent = () => {
  return (
    <ModalContent>
      {(onClose) => (
        <>
          <ModalHeader className="flex flex-col gap-1 font-bangers text-xl">
            Create an account to like
            <p className="text-xs font-sans opacity-70">
              Help improve the community responses by liking the good ones.
            </p>
          </ModalHeader>
          <ModalBody className="flex flex-col gap-4 text-sm">
            <p>
              Plus, you will get all the benefits of having an account.
              It&apos;s free and takes less than 10 seconds.
            </p>
            <CreateAccountBenefits className="mt-4" />
          </ModalBody>
          <ModalFooter>
            <Button
              color="danger"
              variant="light"
              onPress={onClose}
              className="font-bangers"
            >
              Close
            </Button>

            <Button
              color="primary"
              onPress={onClose}
              as={Link}
              href="/sign-up"
              className="font-bold font-bangers shadow-primary-button"
            >
              Create an Account
            </Button>
          </ModalFooter>
        </>
      )}
    </ModalContent>
  );
};

export const CreateAccountBenefits = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <div className={cn("flex flex-col gap-5 mx-4", className)}>
      <div className="flex flex-row gap-4 justify-start items-start">
        <FaBolt className="text-warning text-2xl w-1/12" />
        <div className="flex flex-col gap-1 w-11/12">
          <h1 className="text-lg font-bold leading-none font-bangers text-warning">
            Unlimited Energy
          </h1>
          <p className="text-sm leading-tight">
            Mastery takes practice. Get unlimited energy to put in as many reps
            as you need.
          </p>
        </div>
      </div>
      <div className="flex flex-row gap-4 justify-start items-start">
        <FaBrain className="text-primary text-2xl w-1/12" />
        <div className="flex flex-col gap-1 w-11/12">
          <h1 className="text-lg font-bold leading-none font-bangers text-primary">
            Adaptive Training
          </h1>
          <p className="text-sm leading-tight">
            The more you play, the more we learn about your style, strengths,
            and weaknesses. The game will adapt to you.
          </p>
        </div>
      </div>
      <div className="flex flex-row gap-4 justify-start items-start">
        <FaChartLine className="text-success text-2xl  w-1/12" />
        <div className="flex flex-col gap-1 w-11/12">
          <h1 className="text-lg font-bold leading-none text-success font-bangers">
            Track Progress
          </h1>
          <p className="text-sm leading-tight">
            Advanced analytics to track your progress and see where you need to
            improve. If you can measure it, you can improve it.
          </p>
        </div>
      </div>
      <div className="flex flex-row gap-4 justify-start items-start">
        <FaBook className="text-teal-500 text-2xl  w-1/12" />
        <div className="flex flex-col gap-1 w-11/12">
          <h1 className="text-lg font-bold leading-none font-bangers text-teal-500">
            Build your knowledge base
          </h1>
          <p className="text-sm leading-tight">
            Learn from the wisdom of the crowd. Vote and save your favorate
            responses from the community and access them anytime.
          </p>
        </div>
      </div>
      <div className="flex flex-row gap-4 justify-start items-start">
        <FaVoteYea className="text-secondary text-2xl w-1/12" />
        <div className="flex flex-col gap-1 w-11/12">
          <h1 className="text-lg text-secondary font-bold leading-none font-bangers">
            Influence the Game
          </h1>
          <p className="text-sm leading-tight">
            Vote on features, suggest improvements, and contribute to the
            community to shape the future of the game.
          </p>
        </div>
      </div>
    </div>
  );
};
